import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

/**
 * Renders truncated text with a full-text tooltip on hover.
 * Only shows tooltip when text is actually longer than maxLength chars.
 */
export function TruncatedText({ text, maxLength = 40, className = '' }) {
  if (!text) return <span className={className}>-</span>;

  const needsTooltip = text.length > maxLength;

  if (!needsTooltip) return <span className={className}>{text}</span>;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`cursor-default ${className}`}>{text}</span>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-xs whitespace-pre-wrap break-words text-xs"
          side="top"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
